const DURATION = 1300;

function format(n) {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function animate(el) {
  const target = parseInt(el.dataset.count, 10);
  if (!Number.isFinite(target)) return;

  const suffix = el.dataset.countSuffix || "";
  const start = performance.now();

  const tick = (now) => {
    const t = Math.min((now - start) / DURATION, 1);
    const eased = 1 - Math.pow(1 - t, 3);
    el.textContent = format(Math.round(target * eased)) + suffix;
    if (t < 1) requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

export function initCountUp() {
  const els = document.querySelectorAll("[data-count]");
  if (!els.length) return;

  // Bez wsparcia lub przy zredukowanym ruchu zostawiamy wartość końcową (fallback).
  if (
    !("IntersectionObserver" in window) ||
    matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  // Śledzimy kierunek scrolla, żeby animować tylko przy wejściu „z góry"
  // (scroll w dół, pierwsze czytanie), a nie przy powrocie w kadr od dołu.
  let lastY = window.scrollY;
  let scrollingDown = true;
  addEventListener(
    "scroll",
    () => {
      const y = window.scrollY;
      if (y !== lastY) scrollingDown = y > lastY;
      lastY = y;
    },
    { passive: true },
  );

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (entry.isIntersecting) {
          // Uruchamiamy raz na wejście - flaga chroni przed restartem, dopóki
          // element pozostaje w widoku. Animujemy tylko przy scrollu w dół.
          if (el._counting) return;
          el._counting = true;
          if (scrollingDown) animate(el);
        } else {
          // Wyjście z widoku „zbraja" licznik na kolejne wejście.
          el._counting = false;
        }
      });
    },
    { threshold: 0.4 },
  );

  els.forEach((el) => io.observe(el));
}
